module.exports = __webpack_public_path__ + "img/icon_delete_w.6a12e2ed.svg";